import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useMutation, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { designControlsApi } from "../../api/designControls";
import { useCurrentProduct } from "../useCurrentProduct";

type DesignElement = {
  id: string;
  code: string;
  title: string;
};

export const useDeleteRisk = () => {
  const { t } = useTranslation();
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (element: DesignElement) =>
      designControlsApi.deleteRiskById(companyId, productId, element.id),
    onSuccess: async (_: unknown, element: DesignElement) => {
      showToast({
        title: t("risks.notifications.deleteSuccess.title"),
        description: t("risks.notifications.deleteSuccess.description", {
          code: element.code,
          title: element.title,
        }),
        status: "success",
        "data-cy": "toast-risk-delete-success",
      });
      await queryClient.invalidateQueries([
        "OPEN_ISSUE_LIST",
        companyId,
        productId,
      ]);
    },
    onError: (_: unknown, element: DesignElement) => {
      showToast({
        title: t("risks.notifications.deleteError.title"),
        description: t("risks.notifications.deleteError.description", {
          code: element.code,
          title: element.title,
        }),
        status: "error",
        "data-cy": "toast-risk-delete-error",
      });
    },
  });
};
